@if (rangeValue) {
  <div class="price_range">
    <div class="form_control_group mb-2">
      <div class="form_control_wrapper" (click)="minInput.focus()">
        <span class="font-5">$</span>
        <input
          id="price-min-input"
          #minInput
          class="form_control min-input font-5"
          type="text"
          [value]="rangeValue.inputMinPrice"
          [min]="rangeValue.minPrice"
          [max]="rangeValue.maxPrice"
          (change)="onMinInputChange()"
          (keyup.enter)="onMinInputChange()"
        />
      </div>
      -
      <div class="form_control_wrapper" (click)="maxInput.focus()">
        <span class="font-5">$</span>
        <input
          id="price-max-input"
          #maxInput
          class="form_control font-5"
          type="text"
          [value]="rangeValue.inputMaxPrice"
          [min]="rangeValue.minPrice"
          [max]="rangeValue.maxPrice"
          (change)="onMaxInputChange()"
          (keyup.enter)="onMaxInputChange()"
        />
      </div>
    </div>
    <div class="slider_control_group">
      <input
        id="price-min-slider"
        #minSlider
        class="slider_control"
        type="range"
        [value]="rangeValue.minPrice"
        [min]="rangeValue.minPrice"
        [max]="rangeValue.maxPrice"
        (input)="onMinSliderInput($event)"
      />
      <input
        id="price-max-slider"
        #maxSlider
        class="slider_control"
        type="range"
        [value]="rangeValue.maxPrice"
        [min]="rangeValue.minPrice"
        [max]="rangeValue.maxPrice"
        (input)="onMaxSliderInput($event)"
      />
    </div>
    <div class="price_range_values">
      <span id="price-range-min-value" class="font-5"
        >${{ rangeValue.minPrice | number }}</span
      >
      <span id="price-range-max-value" class="font-5"
        >${{ rangeValue.maxPrice | number }}</span
      >
    </div>
  </div>
}
